exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input_width[data-v-2d6a3780] {\n  width: 80%;\n}\n", ""]);

// exports
